import { Injectable } from '@angular/core';
import { ClaudeResponse, ClaudeParsedResponse, ClaudeAPIError } from '../models/claude.types';

@Injectable({
	providedIn: 'root'
})
export class ClaudeResponseParser {

	parseResponse(response: any): ClaudeParsedResponse {
		if (!response) {
			throw new Error('Empty response received from AI service');
		}

		if (response.type === 'error') {
			throw new ClaudeAPIError(response.error || { type: 'unknown', message: 'Unknown error occurred' });
		}

		if (response.content && Array.isArray(response.content)) {
			const text = response.content
				.filter(c => c.type === 'text' && typeof c.text === 'string')
				.map(c => c.text)
				.join('\n')
				.trim();
			
			return {
				text,
				usage: response.usage || null
			};
		}

		if (typeof response === 'string') {
			return {
				text: response.trim(),
				usage: null
			};
		}

		if (response.text && typeof response.text === 'string') {
			return {
				text: response.text.trim(),
				usage: response.usage || null
			};
		}

		if (response.message && typeof response.message === 'string') {
			return {
				text: response.message.trim(),
				usage: null
			};
		}

		if (response.response && typeof response.response === 'string') {
			return {
				text: response.response.trim(),
				usage: null
			};
		}

		if (Array.isArray(response)) {
			const messages: string[] = [];
			response.forEach(chunk => {
				try {
					if (typeof chunk === 'string') {
						if (chunk.startsWith('data:')) {
							try {
								const parsed = JSON.parse(chunk.replace(/^data:\s*/, ''));
								if (parsed?.content?.length) {
									parsed.content.forEach((c: any) => {
										if (c.type === 'text' && typeof c.text === 'string') {
											messages.push(c.text);
										}
									});
								}
							} catch (e) {
							}
						} else {
							messages.push(chunk);
						}
					} else if (chunk?.content?.length) {
						chunk.content.forEach((c: any) => {
							if (c.type === 'text' && typeof c.text === 'string') {
								messages.push(c.text);
							}
						});
					} else if (chunk?.text) {
						messages.push(chunk.text);
					}
				} catch (err) {
				}
			});
			
			if (messages.length > 0) {
				return {
					text: messages.join('\n').trim(),
					usage: null
				};
			}
		}

		console.warn('Unexpected response format:', response);
		throw new Error('Unable to parse AI response: unexpected format');
	}
}
